import { apiRequest } from 'utils/request'

export const get = async () => {
  const { data } = await apiRequest({ uri: '/outputs' })
  return data
}
